<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" [routerLink]="['/settings/scheduler/schedules']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      @if (reminderId) {
      <h2 class="col pb-2 m-0 title">
        {{ "EDIT_SCHEDULER" | translate }}
      </h2>
      } @else {
      <h2 class="col pb-2 m-0 title">
        {{ "ADD_SCHEDULER" | translate }}
      </h2>
      }
      <p class="col subtitle">
        {{ "REMINDER_SETUP_SUBTITLE" | translate }}
      </p>
    </div>
  </div>

  <form [formGroup]="schedulerForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="name">{{ "NAME" | translate }}</label>
      <div class="form-input">
        <input id="name" formControlName="name" type="text" />
        @if (isControlInvalid('name')) {
        <div class="validation-error">
          {{ "NAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
        } @else if (!nameControl.valid) {
        <div class="validation-instruction">
          {{ "REMINDER_NAMEDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="schedule">{{
        "SCHEDULE" | translate
        }}</label>
      <div class="custom-div">
        <div class="radio-div radio-flex custom-radio-div">
          <div class="element" *ngFor="let item of schedulerTypeDictionary">
            <span class="radiobox" (click)="onSchedulerTypeChange(item)"
              [ngClass]="{ selected: typeControl.value === item, disabled: edit }">
              {{ item }}
              <input id="{{ item }}" type="radio" name="type" formControlName="type" [value]="item" />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (!typeControl.value) {
        <div class="second-subitem" class="validation-instruction">
          {{ "SCHEDULER_TYPEDESC" | translate }}
        </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="timePeriod">{{
        "TIMEPERIOD" | translate
        }}</label>
      <div class="form-cron-input">
        <app-cron-converter formControlName="cron" [config]="cronJobsConfig"></app-cron-converter>
        @if (!cronControl.value) {
        <div class="validation-instruction mt-2">
          {{ "REMINDER_TIMEPERIODDESC" | translate }}
        </div>
        } @else if (cronControl.hasError('everyMinute')) {
        <div class="validation-error mt-2">
          {{ "REMINDER_TIMEPERIODERR" | translate }}
        </div>
        }
      </div>
    </div>

    @if (isPullSchedulerSelected) {
    <div class="horizontal-line"></div>
    <div class="form-item">
      <label class="form-label" for="meterMake">{{ "DEVICESETUP_METERMAKE" | translate }}*</label>
      <div class="form-input">
        <select id="meterMake" (change)="onMeterMakeChange($event)">
          <option value=""></option>
          <option *ngFor="let item of availableMeterMakes" [value]="item.value" [disabled]="isSelectedMeterMake(item)">
            {{ item.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 d-flex align-items-center">
            @if(isControlInvalid('meterMakes')) {
            <div class="validation-error">
              {{ "DEVICESETUP_METERMAKE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
            </div>
            } @else {
            <div *ngIf="selectedMeterMakes.length === 0" class="validation-instruction">
              {{ "DEVICESETUP_METERMAKEDESC" | translate }}
            </div>
            }
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end clear"
            *ngIf="selectedMeterMakes.length > 0" (click)="clearSelectedMeterMakes()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          *ngIf="selectedMeterMakes.length > 0">
          <div *ngFor="let meterMake of selectedMeterMakes"
            class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ meterMake.name }}</span>
            <img (click)="removeMeterMake(meterMake)" alt="Remove Meter Make" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="meterModel">{{ "DEVICESETUP_METERMODEL" | translate }}*</label>
      <div class="form-input">
        <select id="meterModel" (change)="onMeterModelChange($event)"
          [disabled]="selectedMeterMakes.length === 0 || meterModels.length === 0">
          <option value=""></option>
          <option *ngFor="let item of availableMeterModels" [value]="item.value"
            [disabled]="isSelectedMeterModel(item)">
            {{ item.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 d-flex align-items-center">
            @if(isControlInvalid('meterModels')) {
            <div class="validation-error">
              {{ "DEVICESETUP_METERMODEL" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
            </div>
            } @else {
            <div *ngIf="selectedMeterModels.length === 0" class="validation-instruction">
              {{ "DEVICESETUP_METERMODELDESC" | translate }}
            </div>
            }
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end clear"
            *ngIf="selectedMeterModels.length > 0" (click)="clearSelectedMeterModels()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          *ngIf="selectedMeterModels.length > 0">
          <div *ngFor="let meterModel of selectedMeterModels"
            class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ meterModel.name }}</span>
            <img (click)="removeMeterModel(meterModel)" alt="Remove Meter Model"
              src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>
    }

    <div class="horizontal-line"></div>
    <div class="form-item pt-4">
      <label class="form-label" for="region">{{
        "DEVICESETUP_REGION" | translate
        }}</label>
      <div class="form-input">
        <select id="region" (change)="onRegionChange($event)" [value]="''" [disabled]="availableRegions.length === 0">
          <option value=""></option>
          <option *ngFor="let item of availableRegions" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 order-md-2 d-flex align-items-center justify-content-end clear"
            *ngIf="selectedRegions.length > 0" (click)="clearSelectedRegions()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
          <div class="col-6-md validation-instruction" *ngIf="selectedRegions.length === 0">
            {{ "TEAMSETUP_REGIONDESC" | translate }}
            {{ "OPTIONAL" | translate }}.
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          *ngIf="selectedRegions.length > 0">
          <div *ngFor="let region of selectedRegions"
            class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ region.name }}</span>
            <img (click)="removeRegion(region)" alt="Remove Region" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="district">{{
        "DISTRICT" | translate
        }}</label>
      <div class="form-input">
        <select id="area" (change)="onAreaChange($event)" [disabled]="areas.length === 0">
          <option value=""></option>
          <option *ngFor="let item of availableAreas" [value]="item.value" [disabled]="isSelectedArea(item)">
            {{ item.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 d-flex align-items-center">
            <div *ngIf="selectedAreas.length === 0" class="validation-instruction">
              {{ "TEAMSETUP_DISTRICTDESC" | translate }}
              {{ "OPTIONAL" | translate }}.
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end clear" *ngIf="selectedAreas.length > 0"
            (click)="clearSelectedAreas()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3">
          <div *ngFor="let area of selectedAreas" class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ area.name }}</span>
            <img (click)="removeArea(area)" alt="Remove Area" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="horizontal-line"></div>
    <div class="form-item pt-4">
      <label class="form-label" for="assetType">{{ "DEVICESETUP_ASSETTYPE" | translate }}:</label>
      <div class="form-input">
        <select id="assetType" (change)="onAssetTypeChange($event)">
          <option value=""></option>
          <option *ngFor="let item of availableAssetTypes" [value]="item.value" [disabled]="isSelectedAssetType(item)">
            {{ item.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 order-md-2 d-flex align-items-center justify-content-end clear"
            *ngIf="selectedAssetTypes.length > 0" (click)="clearSelectedAssetTypes()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
          @if (selectedAssetTypes.length === 0) {
          <div class="col-md-6 validation-instruction">
            {{ "TEAMSETUP_DISTRICTDESC" | translate }}
            {{ "OPTIONAL" | translate }}.
          </div>
          }
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3">
          <div *ngFor="let asset of selectedAssetTypes"
            class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ asset.name }}</span>
            <img (click)="removeAssetType(asset)" alt="Remove AssetType" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="schedulerForm.invalid" type="submit">
        {{ "CONTINUE" | translate }}
      </button>
      <div [routerLink]="['/settings/scheduler/schedules']">
        <button class="button-cancel" type="button">
          {{ "CANCEL" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>